import { createAction, props } from '@ngrx/store';

import { RestAuditModel } from '@shared/interfaces/audit.interface';

export const loadDelinquencyList = createAction('[Delinquency] load delinquency list', props<{ id: any }>());
export const loadDelinquencyListSucceded = createAction(
  '[Delinquency] load delinquency list succeeded',
  props<{ delinquencyList }>()
);
export const loadDelinquencyListFailed = createAction('[Delinquency] load delinquency list failed');

export const loadDelinquencyById = createAction(
  '[Delinquency] load delinquency by id',
  props<{ delinquencyId: number }>()
);
export const loadDelinquencyByIdSucceded = createAction(
  '[Delinquency] load delinquency by id succeeded',
  props<{ delinquencyDetails }>()
);
export const loadDelinquencyByIdFailed = createAction('[Delinquency] load delinquency by id failed');

export const updateDelinquencyDetailsById = createAction(
  '[Delinquency] update delinquency by id',
  props<{ delinquencyDetails: any }>()
);
export const updateDelinquencyDetailsByIdSucceded = createAction(
  '[Delinquency] update delinquency by id succeeded',
  props<{ delinquencyDetails }>()
);
export const updateDelinquencyDetailsByIdFailed = createAction('[Delinquency] update delinquency by id failed');

/* get changes history */
export const getDelinquencyChangesHistory = createAction(
  '[Delinquency] get changes history',
  props<{ objectId: number }>()
);
export const getDelinquencyChangesHistorySuccess = createAction(
  '[Delinquency] get changes history success',
  props<{ auditModelList: RestAuditModel[] }>()
);
export const getDelinquencyChangesHistoryFailure = createAction('[Delinquency] get changes history failure');
